// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifier-uploader{position:relative;float:right;margin-bottom:.625rem;border:1px solid #c3c4be;border-radius:.25rem;max-width:250px;padding:.625rem .625rem 0 .625rem;color:#000;background:#fff;font-size:12px;clear:both;box-shadow:2px 2px 5px rgba(0,0,0,.25)}h3.notifier-uploader__title{color:#000;font-size:12px}.notifier-uploader__button{text-align:center}", ""]);
// Exports
module.exports = exports;
